import { useContext } from 'react';
import { SellerCartContext } from '../contexts/sellerCartContext';

export const useSellerCart = () => {
    const context = useContext(SellerCartContext);
    if (context === undefined) {
        throw new Error('useSellerCart must be used within a SellerCartProvider');
    }
    return context;
};
